import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.875 2.063H6.188a2.753 2.753 0 0 0-2.75 2.75V19.25a.687.687 0 0 0 .687.688H16.5a.687.687 0 1 0 0-1.375H4.813a1.377 1.377 0 0 1 1.375-1.375h11.687a.687.687 0 0 0 .688-.688V2.75a.69.69 0 0 0-.688-.687m-2.062 8.25-2.201-1.65a.344.344 0 0 0-.412 0l-2.2 1.65V3.436h4.813z"
    }, null, -1)
  ])))
}
export default { render: render }